/* eslint-disable react/jsx-props-no-spreading */
import { Button } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    backgroundColor: ({ color }) => palette[color].main,
    color: ({ color }) => palette[color].contrastText,
    '&:hover': {
      backgroundColor: ({ color }) => palette[color].main,
    },
  },
}));

const CustomButton = ({ color, className, children, ...props }) => {
  const styles = useStyles({ color });

  return (
    <Button className={`${styles.root} ${className}`} {...props}>
      {children}
    </Button>
  );
};

CustomButton.propTypes = {
  color: PropTypes.oneOf([
    'askButton',
    'background',
    'breadcrumbs',
    'drawer',
    'footer',
    'header',
    'mercadolibre',
    'navLink',
    'oddRow',
    'previewPricing',
    'pricing',
    'primary',
    'secondary',
    'separator',
    'theme',
    'whatsapp',
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomButton.defaultProps = {
  children: null,
  className: '',
  color: 'askButton',
};

export default CustomButton;
